import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginAPI } from '../app/shared/constant/url.constant';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  constructor(private readonly http: HttpClient) {}
  getEnvironmentConfig(agencyId: string): Observable<any> {
    return this.http.get(`${LoginAPI.LoginUrl}${agencyId}`);
  }

  getPasswordConfig(agencyId: string): Observable<any> {
    return this.http.get(`${LoginAPI.AccountSetupUrl}${agencyId}`);
  }
}
